export const bmVersion = () => {
  return {
    'bm:version': 3
  };
};